import React from 'react'
import { Link } from 'react-router-dom'


export default function Navigation() {
  return (
    <nav className='navbar navbar-expand-sm bg-danger'>
      <div className='container-fluid'>
        <Link className='text-white navbar-brand' to='/' style={{textDecoration : 'none'}}>沖縄語自然会話コーパス</Link>
        <ul className="navbar-nav" id="navbar-links">
          <li className="nav-item">
            <Link className='text-white nav-link' to='/about' style={{textDecoration : 'none'}}>このコーパスについて</Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}